import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import PageHeader from "../../Utility/PageHeader";
import { useDispatch, useSelector } from "react-redux";
import { FetchCompletedList, FetchCompletedListByBranchId, FetchDriverApprovedList } from "../../redux/vehicleRegistration/FetchDriversData";
import LoadingAnimation from "../../shared/LoadingAnimation";
import NoContentsFound from "../../shared/NoContentsFound";

import DriverCompletedListTable from "./DriverComplatedListTable";
import { useParams } from "react-router-dom";

export default function DriverCompletedList(props) {
  // sendSMS();
  const { t } = useTranslation("translation");
  const data = useSelector((state) => state.vehicle.data);
  const CarsData = useSelector((state) => state.vehicle);
  const loading = useSelector((state) => state.vehicle.loading);
  // const progress = useSelector((state) => state.vehicle.progress);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.authentication.token);
  const type = props.type;
  const {id} = useParams();

  useEffect(() => {
    if(type==="complatedListByBranch"){
      dispatch(FetchCompletedListByBranchId(token, id))
    }else{
      dispatch(FetchCompletedList(token))
    }
  }, []);
  return (
    <div>
      <div className="mt-2">
        <PageHeader title={t("vehicle_details_form.carDetailsRegForm")} />
      </div>
      {loading ? (
        <LoadingAnimation />
      ) : data && data.length>0? (
        <DriverCompletedListTable carsData={CarsData} recordType={t("vehicle_details_form.complatedVehicleList")} />
      ) : (
        <NoContentsFound message={t("general_key_words.dataNotFound")} />
      )}
    </div>
  );
}
